import { useState, useEffect } from "react";

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from "@dnd-kit/sortable";

import SortableColorItem from "./SortableColorItem";

const ColorsInPaletteDragAndDrop = ({
  dataPath,
  dispatch,
  palette,
  updateColorClicked,
  idOfColorSelectedForPickerEdit,
}) => {
  const [activeId, setActiveId] = useState(null);
  const [items, setItems] = useState([]);
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    setItems(palette._colors);
  }, [palette]);

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = async (event) => {
    setActiveId(null);
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = items.findIndex((col) => col.id === active.id);
      const newIndex = items.findIndex((col) => col.id === over.id);
      let newItems = arrayMove(items, oldIndex, newIndex);
      setItems(newItems);

      await dispatch({
        path: [dataPath, palette.id, "_colors", "_order"],
        data: active.id,
        index: newIndex,
      });
    } else {
      updateColorClicked(active.id);
    }
  };

  return (
    // TODO: Lots of duplicate code. be careful if editing to edit both but they do have differences
    !dispatch ?
      <div
        direction="row"
        style={{
          height: "auto",
          width: "224px !important",
          maxWidth: "330px",
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          alignItems: "flex-start",
          borderRadius: "4px",
        }}>
        {items.map((item) => (
          <div
            onClick={() => updateColorClicked(item.id)}
            key={item.id}
          >
            <SortableColorItem
              key={item.id}
              id={item.id}
              handle={true}
              value={item.id}
              color={item.color}
              idOfColorSelectedForPickerEdit={idOfColorSelectedForPickerEdit}
            /></div>
        ))}
      </div>

      :

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        onDragStart={handleDragStart}>
        <div
          direction="row"
          // className={selected ? "button-selected" : ""}
          // onClick={() => setSelected(!selected)}
          style={{
            height: "auto",
            width: "224px !important",
            maxWidth: "330px",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            alignItems: "flex-start",
            borderRadius: "4px",
          }}>
          <SortableContext items={items} strategy={rectSortingStrategy} >
            {items.map((item) => (
              <SortableColorItem
                key={item.id}
                id={item.id}
                handle={true}
                value={item.id}
                color={item.color}
                idOfColorSelectedForPickerEdit={idOfColorSelectedForPickerEdit}
              />
            ))}
          </SortableContext>
        </div>
      </DndContext>
  );
};

export default ColorsInPaletteDragAndDrop;
